export default "__VITE_ASSET__Ca_hkk5z__"